import { FormikProps, FormikValues } from "formik";
import { FC } from "react";

import { useStorageRegionsDropdownOptions } from "queryHooks";
import { TStorageProvider } from "types/apis/storage-regions.types";
import AsyncSelect from "./async-select";

type StorageRegionsSelectProps = {
  optionsQueryConfig: {
    productID?: 1 | 2;
    storageProvider: TStorageProvider;
  };
  name: string;
  type: string;
  placeholder: string;
  formikProps: FormikProps<FormikValues>;
  dataTestId: string;
  isClearable: boolean;
  isMulti?: boolean;
  isInvalid: boolean;
  disabled: boolean;
  onChange: (value: any) => void;
};

const StorageRegionsSelect: FC<StorageRegionsSelectProps> = ({
  optionsQueryConfig,
  ...rest
}) => {
  const { data = [], isLoading } =
    useStorageRegionsDropdownOptions(optionsQueryConfig);

  return <AsyncSelect {...rest} data={data} isLoading={isLoading} />;
};

export default StorageRegionsSelect;
